import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	createWithAIItem: {
		id: 'jira-ai.create-with-ai.create-with-ai-item',
		defaultMessage: 'Create work items with Rovo',
		description: 'The text for the create work items with Rovo item in the dropdown',
	},
	dropdownLabel: {
		id: 'jira-ai.create-with-ai.dropdown-label',
		defaultMessage: 'More options',
		description: 'The label for the more options dropdown',
	},
});
